/**
 * The Insights assistant's icon (the room's chart sender, `senderType 'george'`).
 * A round tile sized by the caller to match the twin avatars beside it.
 */

import { cn } from '@/lib/utils'

export const INSIGHTS_ASSISTANT_ICON_URL = '/insights-assistant.svg'

interface InsightsAssistantAvatarProps {
  /** Size classes matching the neighbouring twin avatars, e.g. `h-7 w-7`. */
  className?: string
  /** Empty when a visible name sits next to the icon. */
  alt?: string
  testId?: string
}

export function InsightsAssistantAvatar(props: InsightsAssistantAvatarProps) {
  const { className, alt = '', testId = 'insights-assistant-avatar' } = props

  return (
    <img
      src={INSIGHTS_ASSISTANT_ICON_URL}
      alt={alt}
      className={cn('shrink-0 rounded-full object-cover', className)}
      data-testid={testId}
    />
  )
}
